import styled from "styled-components"

const Heading = styled.div`
  color: ${(props) => props.theme.textColorLight};
  font-size: ${(props) => props.theme.fontSizeLarge}px;
`

export {Heading}
